module.exports = __webpack_public_path__ + "static/media/YF25_1.d0b4dd56.jpg";